<template>
<div class="home">
    <div style="margin-top:56px;background:#04b2c5" >
        <div class="container" style="margin-top:0px">
            <div class="row">
                <div class="col-md-7">
                    <div class="home-title">
                        <div style="font-size:40px">探索编程</div>
                        <div style="font-size:40px">让未来变得更美好</div>
                        
                        <!-- <div style="margin-top:0px">
                            <button class="btn btn-light" @click="jump('/class')" style="margin-right:20px;
                            color:#04b2c5;font-weight:bold">
                                免费试用编程工具</button>

                            <button class="btn btn-light" @click="jump('/resource')" style="color:#04b2c5;font-weight:bold">课程介绍</button>
                        </div> -->
                        <div style="margin-top: 40px; display: flex;">
                            <img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" style="width:120px;height:120px;"/>
                            <div style="font-size:20px;margin-left:20px;margin-top:45px;"> 扫描二维码获取 免费试听课链接</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <img src="https://tsyyapi.dctechonline.cn/static/images/back3.jpg" style="width:100%;opacity:0.8"/>
                </div>
            
            </div>
        </div>
    </div>
    <div class="container">
       <div style="font-weight: normal;font-size:28px;margin:50px 0px;">四大课程体系<br>涵盖各类编程学习需求</div>

        <div class="row">
            <div class="col-md-3">
                <p class="section-title">编程启蒙课程体系</p>

                <div class="section-content">
                    <div>适合零基础启蒙（8-10岁）</div>
                    <div>游戏化，可视化教学</div>
                    <div>无缝衔接C++或Java编程</div>
                </div>

                <div>
                    <img src="https://tsyyapi.dctechonline.cn/static/images/p1.jpg" class="home-img" style="opacity:0.8;width:90%;height:150px"/>
                </div>
                <!-- <div style="margin-top:20px">
                    <button class="btn btn-outline-info" @click="jump('/entry')">查看详情</button>
                </div> -->
            </div>
            <div class="col-md-3">
                <p class="section-title">C++课程体系</p>
                    <div class="section-content">
                        <div>覆盖基础到竞赛</div>
                        <div>衔接GESP考级</div>
                        <div>衔接CSP-J/S</div>
                    </div>
                <div>
                    <img src="https://tsyyapi.dctechonline.cn/static/images/p2.jpg" class="home-img" style="opacity:0.8;width:90%;height:150px"/>
                </div>
                <!-- <div style="margin-top:20px">
                    <button class="btn btn-outline-info" @click="jump('http://cpp.dctechonline.cn')">查看详情</button>
                </div> -->
            </div>
            <div class="col-md-3">
                <p class="section-title">Java课程体系</p>
                <div class="section-content">
                    <div>覆盖Java基础到竞赛需求</div>
                    <div>AP CSA考试5分目标班</div>
                    <div>USACO 金银铜对标课程班</div>
                </div>
                <div>
                    <img src="https://tsyyapi.dctechonline.cn/static/images/p3.jpg" class="home-img" style="opacity:0.8;width:90%;height:150px"/>
                </div>
                <!-- <div style="margin-top:20px">
                    <button class="btn btn-outline-info" @click="jump('/ap')">查看详情</button>
                </div> -->
            </div>

            
             <div class="col-md-3">
                <p class="section-title">全定制化课程体系</p>
                    <div class="section-content">
                        <div>教学内容根据学生情况定制</div>
                        <div>覆盖Python，Web开发等学习需求</div>
                        <div>计算思维全方位培养</div>
                    </div>
                <div>
                    <img src="https://tsyyapi.dctechonline.cn/static/images/classroom.jpg" class="home-img" style="opacity:0.8;width:90%;height:150px"/>
                </div>
                <!-- <div style="margin-top:20px">
                    <button class="btn btn-outline-info" @click="jump('/algorithm')">查看详情</button>
                </div> -->
            </div> 
        </div>
    </div>


    <div style="background: rgba(0,0,0,0.05);padding:20px 0px;margin:40px 0px;margin-top:40px">
        <div class="container" style="padding-bottom: 30px;">
            <div class="row">
                
                <div class="col-md-4">
                    <h4 style="margin:20px 0px;"><span class="badge badge-info badge-success" style="margin-right:5px;position: relative;top:-3px">1</span>课程特色</h4>
                   
                    <div style="line-height:30px">
                    <div>入门级课程助力快速入门</div>
                    <div>进阶级教学助力快速提高</div>
                    <div>1v1，1v2教学，高效课堂</div>
                    <div>根据孩子的理解能力定制化课堂教学</div>
                </div>
                </div>
                <div class="col-md-4">
                    <h4 style="margin:20px 0px;"><span class="badge badge-info badge-success" style="margin-right:5px;position: relative;top:-3px">2</span>报名上课</h4>
                    <div style="line-height:30px">
                    <div>添加客服确认孩子基本信息</div>
                    <div>安排免费试听课，确认孩子基础</div>
                    <div>安排正式课程上课时间，自动灵活</div>
                    <!-- <div>付款方式灵活多样，无需预付，报名无忧</div> -->
                    </div>
                </div>
                <div class="col-md-4">
                    <h4 style="margin:20px 0px;"><span class="badge badge-info badge-success" style="margin-right:5px;position: relative;top:-3px">3</span>练习与答疑</h4>
                    <div style="line-height:30px">
                    <div>课后建立微信联系，不定时答疑</div>
                    <div>课堂与课后练习互相结合，全在线教学材料</div>
                    
                    <div>比赛竞赛专项辅导，灵活多样</div>
                    <div>其他常见问题，请点击 <a target="new" href="/faq">这里查看</a></div>
                    </div>
                </div>

                <div class="col-md-4">
                    
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-5">
        
        <div class="col-md-7">
          <h3 style="margin:20px 0px">教学师资</h3>
            <p style="text-align: left;">团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。</p>
            <p style="text-align: left;">首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。</p>
        </div>

        <div class="col-md-5">
          <img src="/images/teach.jpg" class="img-fluid" alt="Processing编程教室">
        </div>
      </div>

      <hr/>

      <div class="row" style="margin-top:50px;margin-bottom:50px;">
        <div class="col-md-7">
            <img src="/images/back2.jpg" class="img-fluid" alt="Processing编程教室"></img>

        </div>
        <div class="col-md-5">
            <h3 style="margin:20px 0px">我要上课</h3>
            
            <div style="margin-bottom:20px">联系课程顾问获取课程价格以及上课方式</div>
            <div><img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" style="max-width:180px"/></div>
        </div>
      </div>
    </div>

   
    <div style="height:50px;">&nbsp;</div>
    

    <bottom></bottom>
</div>
  </template>
  
  <script>
  import bottom from '../components/bottom.vue';
  export default {
    name: "HomePage",
    components:{
        bottom
    },
    methods:{
        jump(url){
            // if(url == "coder"){
            //     if(this.$store.state.user == null){
            //         $('#loginDialog').modal('show');
            //         return;
            //     }
            // }
            

            location.href=url;
        },
        sendCode(){

        }
    }
  };
  </script>
  
  <style lang="scss">
  .container {
    margin-top: 30px;
    text-align: center;
  }

  .home{
    img{
        width:100%;
    }

    .section-title{
        font-size:18px;
        font-weight: bold;
        margin-top:30px;
        border:1px solid #cee4f4;
        padding:5px 0px;
        margin-bottom:40px;
        border-radius:5px;
        background:rgb(221, 247, 255);     
    }

    .section-content{
        margin-bottom:30px;
        div{
            height: 30px;
        }
    }

    .home-title
    {
        color:#fff;
        margin-top:30px;
        text-align: left;
        font-size:50px;
        font-weight:bold;
    }

    .home-img{

    }
  }

  @media (max-width:800px) {
    .home .home-title{
        font-size:30px;
        text-align: center;
    }

    .home .home-img{
        height:auto !important;
    }

    
  }
  </style>